import type React from 'react';
import { useCallback } from 'react';
import { debounce } from '@zg-rentals/zdash';
import { Button } from '@zillow/constellation-10';

import { DEBOUNCE_WAIT_TIME } from '@common/constants';

interface IDebouncedButtonProps {
  children: React.ReactNode;
  fluid?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onClick: (...args: Array<any>) => any;
  emphasis?: 'outlined' | 'filled';
  type?: string;
  full?: boolean;
  // following  types will be able to be removed after we delete sharedconstellation directory
  buttonType?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  dataTest?: string;
  tone?: 'brand' | 'neutral' | 'critical';
  loading?: boolean;
}

const DebouncedButton = ({
  onClick,
  children,
  fluid = false,
  size = 'md',
  emphasis = 'filled',
  tone = 'brand',
  disabled = false,
  icon,
  loading = false,
}: IDebouncedButtonProps) => {
  const debouncedOnClick = useCallback(debounce(onClick, DEBOUNCE_WAIT_TIME, true), [onClick]);

  return (
    <Button
      emphasis={emphasis}
      size={size}
      tone={tone}
      fluid={fluid}
      onClick={debouncedOnClick}
      disabled={disabled}
      icon={icon}
      loading={loading}
    >
      {children}
    </Button>
  );
};

export default DebouncedButton;
